import { FormControl } from "@angular/forms";

export enum RegisterControls {
  Firstname = "Firstname",
  Lastname = "Lastname",
  Email = "Email",
  Password = "Password",
  ConfirmPassword = "ConfirmPassword",
}

export interface IRegisterForm {
  [RegisterControls.Email]: FormControl<string>;
  [RegisterControls.Password]: FormControl<string>;
  [RegisterControls.ConfirmPassword]?: FormControl<string>;
  [RegisterControls.Firstname]?: FormControl<string>;
  [RegisterControls.Lastname]?: FormControl<string>;
}
